import type { RosterMember } from '../../hooks/team/useTeamScreenData'
import Avatar, { getInitials } from '../primitives/Avatar'
import styles from './TeamScreen.module.css'

interface RosterListProps {
  members: RosterMember[]
  onSelect: (member: RosterMember) => void
}

export default function RosterList({ members, onSelect }: RosterListProps) {
  return (
    <div className={styles.rlist}>
      {members.map((member) => (
        <button
          key={member.user.id}
          type="button"
          className={[styles.mrow, member.isYou && styles.mrowYou].filter(Boolean).join(' ')}
          data-testid="roster-row"
          onClick={() => onSelect(member)}
        >
          <Avatar
            initials={getInitials(member.user.firstName, member.user.lastName)}
            photoUrl={member.user.photoUrl}
            variant={member.isYou ? 'you' : member.isLeader ? 'leader' : 'default'}
          />
          <div className={styles.minfo}>
            <div className={styles.mname}>
              {member.user.firstName} {member.user.lastName?.charAt(0)}.
              {member.isLeader && (
                <span className={[styles.tag, styles.tagLeader].join(' ')}>Leader</span>
              )}
            </div>
          </div>
          <div className={styles.mrmNum}>
            <span className={styles.mrmVal}>{member.rms}</span>
            <span className={styles.mrmUnit}>RMs</span>
          </div>
        </button>
      ))}
    </div>
  )
}
